module.exports = __webpack_public_path__ + "img/zb.1acb17d5.png";